import { useHighlightContext } from './TableHighlightContext';

export const useHighlightCell = ({ column, row }) => {
  const { highlighting, highlightedCell, setHighlightedCell } =
    useHighlightContext();

  const isHighlighted =
    highlightedCell.column === column || highlightedCell.row === row;

  const handleMouseEnter = () => {
    setHighlightedCell({ column, row });
  };
  const handleMouseLeave = () => {
    setHighlightedCell({ column: -1, row: -1 });
  };

  return {
    isHighlighted,
    highlighting,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
  };
};
